import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useNavigate } from '@remix-run/react';
import { useTranslation } from 'react-i18next';

import PostPaddingContainer from '~/components/Layout/PostPaddingContainer';
import PostCard from '~/components/PostCard';
import Text from '~/components/Text';

import type { Publication } from '~/interfaces/publication';

interface Props {
  publication: Publication;
  recommendedPosts: any;
}

const RecommendedPosts = ({ publication, recommendedPosts }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const postPadding = publication.web_template.post_padding;

  return (
    <PostPaddingContainer postPadding={postPadding} classNames="mx-auto w-full max-w-2xl pb-8">
      <Text as="h4" size="xl" theme="content" weight="bold" className="pb-6 leading-none sm:pb-2">
        {t('posts.keep_reading')}
      </Text>
      <div className="space-y-6">
        <div className="flex flex-col">
          {recommendedPosts.map((post: any) => {
            return (
              <PostCard
                key={post.id}
                publication={publication}
                post={post}
                titleSize="md"
                descriptionSize="sm"
                showImage={true}
                orientation="horizontal"
              />
            );
          })}
        </div>
        <button
          type="button"
          className="hover flex items-center text-sm text-wt-primary transition-all hover:font-medium"
          onClick={() => navigate('/')}
        >
          <span>{t('shared.cta.view_more')}</span>
          <ChevronRightIcon className="ml-0.5 h-3 w-3 pt-0.5" />
        </button>
      </div>
    </PostPaddingContainer>
  );
};

export default RecommendedPosts;
